import { useQuery, QueryResult } from '@apollo/client';
import { gql } from '@apollo/client';

const GET_AUDIT_DOCUMENT_DOCX = gql`
  query GetAuditDocumentDocx($documentId: String) {
    getAuditDocumentDocx(documentId: $documentId) {
      fileBase64
      fileName
      mimeType
    }
  }
`;

interface AuditDocumentDocx {
  fileBase64: string;
  fileName: string;
  mimeType: string;
}

interface GetAuditDocumentDocxData {
  getAuditDocumentDocx: AuditDocumentDocx;
}

interface GetAuditDocumentDocxVariables {
  documentId: string;
}

export const useGetAuditDocumentDocx = (documentId: string): QueryResult<GetAuditDocumentDocxData, GetAuditDocumentDocxVariables> => {
  return useQuery<GetAuditDocumentDocxData, GetAuditDocumentDocxVariables>(GET_AUDIT_DOCUMENT_DOCX, {
    variables: { documentId },
  });
};

